import { render, staticRenderFns } from "./stepTwo.vue?vue&type=template&id=6c832f9a&scoped=true&"
import script from "./stepTwo.vue?vue&type=script&lang=js&"
export * from "./stepTwo.vue?vue&type=script&lang=js&"
import style0 from "./stepTwo.vue?vue&type=style&index=0&id=6c832f9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c832f9a",
  null
  
)

export default component.exports